import React from 'react';
import Sidebar from './Sidebar';
import { Construction } from 'lucide-react';

export default function UnderConstruction({ title, description }) {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 md:ml-64 p-4 md:p-8">
        <div className="max-w-4xl mx-auto text-center py-16">
          <Construction className="w-16 h-16 mx-auto mb-4 text-amber-500" />
          <h1 className="text-3xl md:text-4xl font-light mb-3">{title}</h1>
          <p className="text-muted-foreground text-lg">{description}</p>
        </div>
      </main>
    </div>
  );
}
